import { FeatureFlags } from '../../../Api/useFeatureFlags';
import { isAdmin, isExecutiveFull, isSupport } from '../../../store/User';
import { User } from '../../../types';

interface OptionalAdminTab {
  name: string;
  flag?: keyof FeatureFlags;
  isEligible: (user?: User) => boolean;
}

const OPTIONAL_ADMIN_TABS: OptionalAdminTab[] = [
  {
    name: 'Support',
    flag: 'support_entitlements',
    isEligible: (user) => isAdmin(user) || isSupport(user)
  },
  {
    name: 'Asset Converter',
    isEligible: (user) => isAdmin(user) || isSupport(user) || isExecutiveFull(user)
  },
  {
    name: 'MCP Access',
    flag: 'mcp_access_profiles',
    isEligible: (user) => isAdmin(user)
  },
  {
    name: 'Project Management Configuration',
    flag: 'projects_updates',
    isEligible: (user) => isAdmin(user)
  },
  {
    name: 'Permission Sets',
    flag: 'permission_sets',
    isEligible: (user) => isAdmin(user)
  },
  {
    name: 'Block List',
    flag: 'block_list',
    isEligible: (user) => isAdmin(user)
  }
];

const OPTIONAL_TAB_NAMES = new Set(OPTIONAL_ADMIN_TABS.map((tab) => tab.name));

export const getEligibleOptionalTabs = (
  currentTabs: string[],
  featureFlags: FeatureFlags | null | undefined,
  user: User | undefined
): string[] => {
  if (!featureFlags) return currentTabs;
  // Recompute from the base tabs so the gate is reversible: strip every optional
  // tab, then re-append only the currently-eligible ones.
  const baseTabs = currentTabs.filter((name) => !OPTIONAL_TAB_NAMES.has(name));
  const eligible = OPTIONAL_ADMIN_TABS.filter(
    (tab) => (!tab.flag || featureFlags[tab.flag]) && tab.isEligible(user)
  ).map((tab) => tab.name);
  return [...baseTabs, ...eligible];
};

export const reconcileSelectedTab = (prevTabs: string[], nextTabs: string[], selectedIndex: number): number => {
  const activeTab = prevTabs[selectedIndex];
  // Index points past the current list (e.g. a persisted tab restored before its
  // flag has loaded) — leave it so the restore can land once the list grows.
  if (activeTab === undefined) return selectedIndex;
  const nextIndex = nextTabs.indexOf(activeTab);
  return nextIndex >= 0 ? nextIndex : 0;
};
